"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** deprecated */
exports.default = {
    url: 'http://localhost:7000',
};
